import { PERMISSIONS } from '../../constants';
import list from './DiscountList';
// O cadastro novo (v2). O antigo segue em /discounts/create-classic (customRoutes.tsx).
import create from './v2';
import show from './DiscountShow';

export default {
  list,
  create,
  show,
  name: 'discounts',
  permissions: [PERMISSIONS.FUEL_DISCOUNTS]
}